import React from "react";

export default function Right() {
  return <i className="fas fa-chevron-right" />;
}
